// src/App.js
import { useContext } from 'react'
import { BrowserRouter, Routes, Route } from 'react-router-dom'
import { ThemeContext } from './contexts/theme'

import Header from './components/Header/Header'
import Footer from './components/Footer/Footer'
import ScrollToTop from './components/ScrollToTop/ScrollToTop'

import HomePage from './pages/HomePage'
import ResumePage from './pages/ResumePage'
import AboutPage from './pages/AboutPage'

import './App.css'
import NowPage from './pages/NowPage'

export default function App() {
  const [{ themeName }] = useContext(ThemeContext)

  return (
    <BrowserRouter>
      <div id="top" className={`${themeName} app`}>
        <Header />

        <main>
          <Routes>
            <Route path="/" element={<HomePage />} />
            <Route path="/resume" element={<ResumePage />} />
            <Route path="/about" element={<AboutPage />} />
            <Route path="/now" element={<NowPage/>}/>
          </Routes>
        </main>

        <ScrollToTop />
        <Footer />
      </div>
    </BrowserRouter>
  )
}